import { render, staticRenderFns } from "./TitleChip.vue?vue&type=template&id=3b6a5724&scoped=true&"
import script from "./TitleChip.vue?vue&type=script&lang=js&"
export * from "./TitleChip.vue?vue&type=script&lang=js&"
import style0 from "./TitleChip.vue?vue&type=style&index=0&id=3b6a5724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a5724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
